import { useMemo, useRef } from 'react';

function useMemoizedDeps(deps, comparator) {
  var memoizedDeps = useRef(deps);

  if (!comparator(deps, memoizedDeps.current)) {
    memoizedDeps.current = deps;
  }

  return memoizedDeps.current;
}

function useMemoWithComparator(callback, deps, comparator) {
  var memoizedDeps = useMemoizedDeps(deps, comparator);
  return useMemo(callback, memoizedDeps);
}

export { useMemoWithComparator };
//# sourceMappingURL=react-use-memo-with-comparator.esm.js.map
